module.exports = __webpack_public_path__ + "static/img/12.5813020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/12.png
// module id = LugO
// module chunks = 0